import React from 'react';
import { Select, MenuItem } from '@mui/material';

import Input from '../../../../components/searchInput';

import {
    OptionsContainer,
    SearchContainer,
    SelectInput,
    SelectContainer
} from '../styles';

export const UsuariosFiltros = ({
    search,
    setSearch,
    limit,
    setLimit,
    statusFilter,
    setStatusFilter,
    tableLimits,
    tableStatusFilter
}) => {
    return (
        <OptionsContainer>
            <SearchContainer>
                <Input
                    onChange={(e) => {
                        setSearch(e);
                    }}
                    onClean={() => {
                        setSearch('');
                    }}
                    title="Pesquisar por email ou CPF"
                    query={search}
                    style={{
                        borderWidth: 1,
                        borderColor: 'grey',
                        borderRadius: 5,
                        width: '100%'
                    }}
                />
            </SearchContainer>
            <SelectContainer>
                <Select
                    value={limit}
                    onChange={(e) => {
                        setLimit(e.target.value);
                    }}
                    input={<SelectInput />}
                    style={{ width: '100%' }}
                >
                    <MenuItem disabled>Registros</MenuItem>
                    {tableLimits.map((currentLimit, index) => (
                        <MenuItem value={currentLimit} key={index}>
                            {currentLimit}
                        </MenuItem>
                    ))}
                </Select>
            </SelectContainer>
            <SelectContainer>
                <Select
                    value={statusFilter}
                    onChange={(e) => {
                        setStatusFilter(e.target.value);
                    }}
                    input={<SelectInput />}
                    style={{ width: '100%' }}
                >
                    <MenuItem disabled>Status</MenuItem>
                    {tableStatusFilter.map((status, index) => (
                        <MenuItem value={status} key={index}>
                            {status}
                        </MenuItem>
                    ))}
                </Select>
            </SelectContainer>
        </OptionsContainer>
    );
};
